export * from './Details';
export * from './Feedback/feedback.component';
